import { request } from '@/shared/api';
export function postAgentChatMessage(input) {
    return request('/api/v1/agent-chat/messages', {
        method: 'POST',
        body: JSON.stringify({
            tabId: input.tabId,
            content: input.content,
            attachment: input.attachment,
        }),
    });
}
export function fetchProactiveAgentChatMessages(input) {
    const params = new URLSearchParams();
    if (input?.ack === false)
        params.set('ack', 'false');
    if (input?.limit != null)
        params.set('limit', String(input.limit));
    const query = params.toString();
    return request(`/api/v1/agent-chat/proactive${query ? `?${query}` : ''}`);
}
